import { writable } from 'svelte/store';
import * as util from "../js/util.js";

function createMyStore() {
    const { subscribe, set, update, get } = writable("");

    return {
        subscribe,
        set, get, update
    };
}
export const languageFilterStore = createMyStore();

